/* eslint-disable react/no-find-dom-node */

// @flow

import React, {PureComponent} from 'react';

import './ConceptButton.module.scss';

type PropTypes = {
  group: string,
  selectedGroup: string,
  setSelectedGroup: Function,
};

class GroupButton extends PureComponent {
  props: PropTypes;

  state = {};

  render() {
    const {group, selectedGroup, setSelectedGroup}: any = this.props;

    return (
      <button
        type="button"
        styleName={selectedGroup === group ? 'button-active' : 'button-inactive'}
        onClick={() => setSelectedGroup(group)}
        automation-id={`diametricsItem-${group}`}
      >
        {group}
        <span />
        <div className="icon icn-icon-dimmet-group" styleName="group-button-icon" />
      </button>
    );
  }
}

export default GroupButton;
